import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SurveyService } from 'src/app/services/survey.service';
import { UrlService } from 'src/app/services/url.service';
import { AppMessage } from 'src/app/utils/appMessage';
import { DateHelpers } from 'src/app/utils/date.helper';
import { EncryptDecryptService } from 'src/app/utils/encrypt-decrypt.service';
import { HelperService } from 'src/app/utils/helpers';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

  public formAuth!: FormGroup<any>;
  public formAuthOTP!: FormGroup<any>;
  public errorMessages = AppMessage.errorMessages;

  errorPhoneNumber: string | undefined;
  errorOTP: string | undefined;
  errorMessageOtp: string | undefined;

  disableFormPhone = true
  disableFormOtp = true
  isLoading: boolean = false;

  dataVipMember: any = []
  dataCustomer: any = []

  constructor(
    private dateHelper: DateHelpers,
    private service: SurveyService,
    private helper: HelperService,
    private encryptDecryptService: EncryptDecryptService,
    private fb: FormBuilder,
    private url: UrlService
  ) {


  }

  ngOnInit(): void {
    this.initFormAuth()
    this.initFormAuthOtp()

  }

  initFormAuth() {
    this.formAuth = this.fb.group({
      phone: ['', [
        Validators.required, Validators.pattern(new RegExp('[0-9_-]{10,13}'))
      ]]
    })
  }

  initFormAuthOtp() {
    this.formAuthOTP = this.fb.group({
      otp: ['']
    })
  }

  onPreviousPage(link:any) {
    this.url.getWindow().open(link, '_self')
  }

  // section vip members
  phonesCheck(p: string) {
    p = String(p).trim();
    const phone = p.charAt(0) + p.charAt(1);
    if (phone === '62') {
      return '+' + p;
    } else if (p.charAt(0) === '0') {
      return p.replace('0', '+62');
    } else if (p) {
      return '+62' + p;
    } else {
      return p.replace(/[- .]/g, '');
    }
  }

  onNextPage(ev:any) {

    if (ev == "sendOTP") {
      const data = this.formAuth.value
      if (data.phone == undefined || data.phone == '' || data.phone == null) {
        this.errorPhoneNumber = "Mohon masukkan nomor telepon Anda dengan benar untuk keperluan verifikasi.";
      }else {
        const body = {
          company: "PD",
          phone: this.phonesCheck(data.phone)
        }

        const isData = {
          data: body
        }

        this.isLoading = true
        this.service.sendotp(isData).subscribe((r) => {
          const data = r.data
          if (r.status === 200) {
            this.isLoading = false
            this.dataCustomer = data
            this.disableFormPhone = false // masuk ke form otp
          }
          if (r.status === 404) {
            this.isLoading = false
            this.errorMessageOtp = r.message
          }
        }, (e) => {
          this.isLoading = false
          this.errorMessageOtp = "Maaf, Anda belum termasuk dalam target responden survei ini. Terima kasih!"
          console.error(e)
        })
      }
    } else {
      const dataAuth = this.formAuth.value
      const data = this.formAuthOTP.value
      if (data.otp == undefined || data.otp == '' || data.otp == null) {
        this.errorOTP = "Harap masukkan kode OTP"
      } else {
        // console.log('onNext Input OTP')
        const body = {
          company: "PD",
          phone: this.phonesCheck(dataAuth.phone),
          otpnumber: data.otp,
        }
        const isData = {
          data: body
        }
        this.isLoading = true
        this.service.verificationotp(isData).subscribe((r) => {
          const data = r.data

          if (r.status === 200) {
              this.isLoading = false
              this.dataVipMember = data[0]
              this.disableFormOtp = false
          }
          if (r.status === 120) {
            this.goToPage('e?id='+data.ref_id+'&s=true')
            // jika sudah melakukan survey
            // redirect ke voucher
          }

          if (r.status === 404) {
            this.isLoading = false
            this.errorOTP = "OTP telah kedaluwarsa."
          }
        }, (e) => {
          this.isLoading = false
          this.errorOTP = "OTP telah kedaluwarsa."
          console.error(e)
        })
      }

    }
  }

  goToPage(link: any) {
    this.url.getWindow().open(link, '_self')
  }

  goToQ(refifotp: any,phone: any,vip:any,show:any) {
    // const newphone =  this.encryptDecryptService.encryptUsingAES256(JSON.stringify(phone))
    this.goToPage('q?id='+refifotp+'&s='+show)
  }




}
